import { GeneralComponent } from './../../../../../shared/general.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormularioService } from 'src/app/services/formulario.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GeneralService } from 'src/app/services/general.service';
import { map, startWith, take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
  selector: 'app-modal-comment-pc003',
  templateUrl: './modal-comment-pc003.component.html',
  styleUrls: ['./modal-comment-pc003.component.scss']
})
export class ModalCommentPc003Component extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;


  public listHibrido?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listHibridoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  constructor(
    protected formularioService: FormularioService,
    public dialogRef: MatDialogRef<ModalCommentPc003Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected formBuilder: FormBuilder,
    protected generalService: GeneralService,
    protected notificationService: NotificationService,
  ) {
    super();
    this.formulario = this.formBuilder.group({
      pc_hibrido: ['', []],
      comment: ['', []],
    })
  }

  async ngOnInit() {

    console.log(this.data);
    if (this.data.isEdit) {
      this.formulario.get('comment').setValue(this.data.pc003.comment)
    }
    else {
      this.listHibrido = new Array<DropDownListDTO>();
      await this.getLists();
    }

  }
  async closeModal(): Promise<void> {
    this.dialogRef.close({ save: false });

  }
  async saveConfirm($event: any): Promise<void> {
    this.data.pc003.comment = this.formulario.get('comment').value as string;
    this.data.pc003.pc_hibrido = !this.data.isDelete && this.data.pc003.pc_hibrido == null ? this.formulario.get('pc_hibrido').value as string : this.data.pc003.pc_hibrido
    // this.parentRef.saveConfirm(this.change);

    this.dialogRef.close({ save: true, data: this.data.pc003 });

  }

  async getLists(): Promise<void> {
    await Promise.all([this.getListHibrido()]);
  }




  async getListHibrido(): Promise<void> {
    await this.formularioService.getListDropDownList('qua007', 'hibrido_rnc').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listHibrido = this.generalService.orderByDropDownList(
          response.data as DropDownListDTO[]
        );
        this.listHibridoOriginal = this.listHibrido;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
    });
  }
  async getFilters(): Promise<void> {
    await Promise.all([this.createFilterHibrido()])
  }


  async createFilterHibrido(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listHibridoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listHibrido = this.listHibridoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listHibrido = this.listHibridoOriginal;
      }
    } else {
      this.listHibrido = this.listHibridoOriginal;
    }
  }

}
